import { Dialog, Button, DialogTitle, DialogActions, DialogContent } from '@mui/material';
import PropTypes from 'prop-types';
import { HOST_API_URL } from '../../../../../config-global';
import { fileData } from '../../../../../reusable-components/file-thumbnail/utils';

FilePreviewModal.propTypes = {
  isDialogOpen: PropTypes.bool,
  handleDialogOpen: PropTypes.func,
  FORMAT_IMG: PropTypes.array,
  previewFile: PropTypes.object,
};
export default function FilePreviewModal({isDialogOpen, handleDialogOpen, FORMAT_IMG, previewFile}) {

  const getTicketFile = async () => {
    window.open(`${HOST_API_URL}Api/TicketFile?noteId=${previewFile?.id}&download=true`, '_blank');
  };

  return (
    <Dialog
      open={isDialogOpen}
      onClose={(event, reason) => {
        if (reason === 'backdropClick' || reason === 'escapeKeyDown') return;
        handleDialogOpen();
      }}
    >
      {previewFile?.name && FORMAT_IMG.includes(fileData(previewFile?.name).type) ? (
        <DialogContent>
          <img
            src={`/api/TicketFile?noteId=${previewFile?.id}&download=false`}
            alt={previewFile?.name}
            style={{ maxWidth: "100%", maxHeight: "70vh" }}
          />
        </DialogContent>
      ) : previewFile?.name && fileData(previewFile?.name).type === "pdf" ? (
        <DialogContent>
          <iframe
            src={`/api/TicketFile?noteId=${previewFile?.id}&download=false#toolbar=0&navpanes=0`}
            title="PDF Preview"
            width="100%"
            height="375px"
            style={{ border: "none" }}
          />
        </DialogContent>
      ) : <DialogTitle>No File Preview Available</DialogTitle>}
      <DialogActions>
        <Button
          onClick={getTicketFile}
          sx={{ mt: 2 }}
          variant="contained"
          color="primary"
        >
          Download
        </Button>
        <Button onClick={handleDialogOpen} sx={{ mt: 2, ml: 2 }}>
          Close
        </Button>
      </DialogActions>
    </Dialog>
  )
}